<div class="layout-footer">
    <div class="footer-logo-container">
        <img [src]="'assets/layout/logo/sa-color-logo.png'" class="mr-4" alt="sa-logo" style="width: 15rem;height: 4rem;"/>
        
    </div>
    <span class="footer-copyright">&#169; Siamese Asset PLC - 2024</span>
</div>
